export const defaultCustomPlanFormData = {
  customerLabel: '',
  planName: 'Custom',
  monthlyPrice: '',
  billingCycle: 'monthly',
  annualDiscount: 20,
  unlimitedEmployees: true,
  employeeLimit: 25,
  features: [],
  customerNotes: '',
  internalNotes: '',
};

export function formDataToTerms(formData) {
  const monthlyPrice = parseFloat(String(formData.monthlyPrice || ''));
  const employees = formData.unlimitedEmployees
    ? -1
    : parseInt(String(formData.employeeLimit || 1), 10);

  return {
    planName: String(formData.planName || 'Custom').trim(),
    monthlyPrice,
    billingCycle: formData.billingCycle === 'annually' ? 'annually' : 'monthly',
    annualDiscount: Number(formData.annualDiscount) || 20,
    limits: {
      employees: Number.isFinite(employees) ? employees : 1,
      appointments: -1,
    },
    features: (formData.features || []).map((f) => String(f).trim()).filter(Boolean),
    customerNotes: String(formData.customerNotes || '').trim() || undefined,
    internalNotes: String(formData.internalNotes || '').trim() || undefined,
  };
}

export function planToFormData(plan) {
  const terms = plan?.terms || {};
  const employees = terms.limits?.employees ?? -1;
  return {
    customerLabel: plan?.customerLabel || '',
    planName: terms.planName || 'Custom',
    monthlyPrice: terms.monthlyPrice != null ? String(terms.monthlyPrice) : '',
    billingCycle: terms.billingCycle === 'annually' ? 'annually' : 'monthly',
    annualDiscount: terms.annualDiscount ?? 20,
    unlimitedEmployees: employees === -1,
    employeeLimit: employees === -1 ? 25 : employees,
    features: Array.isArray(terms.features) ? [...terms.features] : [],
    customerNotes: terms.customerNotes || '',
    internalNotes: terms.internalNotes || '',
  };
}
